import {useReportsSpreadsheetContext} from 'modules/reports/components/Spreadsheet/ReportsSpreadsheet.context'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import useStyles from './ReportsSpreadsheetAppend.styles'

type Props = {}

function ReportsSpreadsheetAppend(props: Props) {
  const classes = useStyles()
  const {prefix, onNewColumn} = useReportsSpreadsheetContext()
  const p = usePrefix(`${prefix}-new-column`)

  return (
    <th className={classes.root} data-testid={p()} onClick={onNewColumn}>
      Add
    </th>
  )
}

export default ReportsSpreadsheetAppend
